export default __webpack_public_path__ + "assets/images/visa.e4723e2851ea19ef18dff4450b54785d.svg";